import React from "react";
import { List } from "../modules/Results";

export function ResultsListPage() {
  return <List />;
}
